import React from 'react';
import { Header, Segment } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

const Home = ({ t }) => {
    return (
        <Segment textAlign='center'>
            <Header as='h3' color='teal' content={t('WelcomeToOb')} />
        </Segment>

    );
};

export default withTranslation()(Home);
